/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientJoinLogDto } from '../models/client-join-log-dto';
import { clientWorkspaceJoinLogControllerAcceptJoinRequest } from '../fn/client-workspace-join-log/client-workspace-join-log-controller-accept-join-request';
import { ClientWorkspaceJoinLogControllerAcceptJoinRequest$Params } from '../fn/client-workspace-join-log/client-workspace-join-log-controller-accept-join-request';
import { clientWorkspaceJoinLogControllerCancelJoinRequest } from '../fn/client-workspace-join-log/client-workspace-join-log-controller-cancel-join-request';
import { ClientWorkspaceJoinLogControllerCancelJoinRequest$Params } from '../fn/client-workspace-join-log/client-workspace-join-log-controller-cancel-join-request';
import { clientWorkspaceJoinLogControllerJoinUser } from '../fn/client-workspace-join-log/client-workspace-join-log-controller-join-user';
import { ClientWorkspaceJoinLogControllerJoinUser$Params } from '../fn/client-workspace-join-log/client-workspace-join-log-controller-join-user';
import { clientWorkspaceJoinLogControllerRejectJoinRequest } from '../fn/client-workspace-join-log/client-workspace-join-log-controller-reject-join-request';
import { ClientWorkspaceJoinLogControllerRejectJoinRequest$Params } from '../fn/client-workspace-join-log/client-workspace-join-log-controller-reject-join-request';
import { clientWorkspaceJoinLogControllerSearchCursor } from '../fn/client-workspace-join-log/client-workspace-join-log-controller-search-cursor';
import { ClientWorkspaceJoinLogControllerSearchCursor$Params } from '../fn/client-workspace-join-log/client-workspace-join-log-controller-search-cursor';
import { clientWorkspaceJoinLogControllerSearchOffset } from '../fn/client-workspace-join-log/client-workspace-join-log-controller-search-offset';
import { ClientWorkspaceJoinLogControllerSearchOffset$Params } from '../fn/client-workspace-join-log/client-workspace-join-log-controller-search-offset';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class ClientWorkspaceJoinLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clientWorkspaceJoinLogControllerSearchOffset()` */
  static readonly ClientWorkspaceJoinLogControllerSearchOffsetPath = '/api/clientWorkspaceJoinLog/join/search/offset';

  /**
   * 워크스페이스 가입 내역 오프셋 기반 검색.
   *
   * 워크스페이스 가입 내역을 오프셋 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceJoinLogControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceJoinLogControllerSearchOffset$Response(params: ClientWorkspaceJoinLogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return clientWorkspaceJoinLogControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 워크스페이스 가입 내역 오프셋 기반 검색.
   *
   * 워크스페이스 가입 내역을 오프셋 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceJoinLogControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceJoinLogControllerSearchOffset(params: ClientWorkspaceJoinLogControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.clientWorkspaceJoinLogControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceJoinLogControllerSearchCursor()` */
  static readonly ClientWorkspaceJoinLogControllerSearchCursorPath = '/api/clientWorkspaceJoinLog/join/search/cursor';

  /**
   * 워크스페이스 가입 내역 커서 기반 검색.
   *
   * 워크스페이스 가입 내역을 커서 기반으로 검색합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceJoinLogControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceJoinLogControllerSearchCursor$Response(params: ClientWorkspaceJoinLogControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return clientWorkspaceJoinLogControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 워크스페이스 가입 내역 커서 기반 검색.
   *
   * 워크스페이스 가입 내역을 커서 기반으로 검색합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceJoinLogControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceJoinLogControllerSearchCursor(params: ClientWorkspaceJoinLogControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.clientWorkspaceJoinLogControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceJoinLogControllerJoinUser()` */
  static readonly ClientWorkspaceJoinLogControllerJoinUserPath = '/api/clientWorkspaceJoinLog/{id}/join';

  /**
   * 워크스페이스 가입 요청.
   *
   * 워크스페이스에 가입을 요청합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceJoinLogControllerJoinUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceJoinLogControllerJoinUser$Response(params: ClientWorkspaceJoinLogControllerJoinUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientJoinLogDto>> {
    return clientWorkspaceJoinLogControllerJoinUser(this.http, this.rootUrl, params, context);
  }

  /**
   * 워크스페이스 가입 요청.
   *
   * 워크스페이스에 가입을 요청합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceJoinLogControllerJoinUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceJoinLogControllerJoinUser(params: ClientWorkspaceJoinLogControllerJoinUser$Params, context?: HttpContext): Observable<ClientJoinLogDto> {
    return this.clientWorkspaceJoinLogControllerJoinUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientJoinLogDto>): ClientJoinLogDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceJoinLogControllerAcceptJoinRequest()` */
  static readonly ClientWorkspaceJoinLogControllerAcceptJoinRequestPath = '/api/clientWorkspaceJoinLog/{id}/join/{joinId}/accept';

  /**
   * 워크스페이스 가입 승인.
   *
   * 워크스페이스에 가입을 요청한 사용자의 가입을 승인합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceJoinLogControllerAcceptJoinRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceJoinLogControllerAcceptJoinRequest$Response(params: ClientWorkspaceJoinLogControllerAcceptJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientJoinLogDto>> {
    return clientWorkspaceJoinLogControllerAcceptJoinRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * 워크스페이스 가입 승인.
   *
   * 워크스페이스에 가입을 요청한 사용자의 가입을 승인합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceJoinLogControllerAcceptJoinRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceJoinLogControllerAcceptJoinRequest(params: ClientWorkspaceJoinLogControllerAcceptJoinRequest$Params, context?: HttpContext): Observable<ClientJoinLogDto> {
    return this.clientWorkspaceJoinLogControllerAcceptJoinRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientJoinLogDto>): ClientJoinLogDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceJoinLogControllerRejectJoinRequest()` */
  static readonly ClientWorkspaceJoinLogControllerRejectJoinRequestPath = '/api/clientWorkspaceJoinLog/{id}/join/{joinId}/reject';

  /**
   * 워크스페이스 가입 거부.
   *
   * 워크스페이스에 가입을 요청한 사용자의 가입을 거부합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceJoinLogControllerRejectJoinRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceJoinLogControllerRejectJoinRequest$Response(params: ClientWorkspaceJoinLogControllerRejectJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientJoinLogDto>> {
    return clientWorkspaceJoinLogControllerRejectJoinRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * 워크스페이스 가입 거부.
   *
   * 워크스페이스에 가입을 요청한 사용자의 가입을 거부합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceJoinLogControllerRejectJoinRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceJoinLogControllerRejectJoinRequest(params: ClientWorkspaceJoinLogControllerRejectJoinRequest$Params, context?: HttpContext): Observable<ClientJoinLogDto> {
    return this.clientWorkspaceJoinLogControllerRejectJoinRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientJoinLogDto>): ClientJoinLogDto => r.body)
    );
  }

  /** Path part for operation `clientWorkspaceJoinLogControllerCancelJoinRequest()` */
  static readonly ClientWorkspaceJoinLogControllerCancelJoinRequestPath = '/api/clientWorkspaceJoinLog/join/{id}/cancel';

  /**
   * 가입 요청 취소.
   *
   * 가입 요청을 취소합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientWorkspaceJoinLogControllerCancelJoinRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceJoinLogControllerCancelJoinRequest$Response(params: ClientWorkspaceJoinLogControllerCancelJoinRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientJoinLogDto>> {
    return clientWorkspaceJoinLogControllerCancelJoinRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * 가입 요청 취소.
   *
   * 가입 요청을 취소합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientWorkspaceJoinLogControllerCancelJoinRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientWorkspaceJoinLogControllerCancelJoinRequest(params: ClientWorkspaceJoinLogControllerCancelJoinRequest$Params, context?: HttpContext): Observable<ClientJoinLogDto> {
    return this.clientWorkspaceJoinLogControllerCancelJoinRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientJoinLogDto>): ClientJoinLogDto => r.body)
    );
  }

}
